import { useState, useCallback } from "react";
import {
  authHeader,
  authHeaderFileUpload,
  getApiUrl,
  getAuthToken,
} from "../apiService/authHeader";
import { useNavigate } from "react-router-dom";

const useHttpRequests = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const sendRequest = useCallback(async (request, returnResponse) => {
    setIsLoading(true);
    setError(null);
    try {
      let requestOptions = {};

      if (!request.method) {
        requestOptions = {
          method: "POST",
          headers:
            request.url === "Account/authenticate"
              ? {
                  Accept: "application/json",
                  "Content-Type": "application/json; charset=utf-8",
                }
              : authHeader(),
          body: request.body ? JSON.stringify(request.body) : {},
        };
      } else if (request.method && request.header) {
        requestOptions = {
          method: "GET",
          headers: authHeader(),
        };
      } else if (
        request.method === "PUT" ||
        request.method === "PATCH" ||
        request.method === "DELETE"
      ) {
        requestOptions = {
          method: request.method,
          headers: authHeader(),
          body: request.body ? JSON.stringify(request.body) : {},
        };
      } else if (request.method === "fileUpload") {
        requestOptions = {
          method: "POST",
          headers: authHeaderFileUpload(),
          body: request.body,
        };
      } else {
        requestOptions = { method: request.method };
      }

      const response = await fetch(getApiUrl() + request.url, requestOptions);

      if (
        !response.ok ||
        response.message === "Authorization has been denied for this request."
      ) {
        if ([401, 403].indexOf(response.status) !== -1) {
          // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
          //localStorage.removeItem("accessToken");
          localStorage.removeItem("currentUser");
          console.log("Unauthorized access!");
          navigate("/login");
        }
      } else if (request.url === "Account/authenticate") {
        const extractToken = response.headers.get(getAuthToken());
        localStorage.setItem("accessToken", extractToken);
      } else if ([204].indexOf(response.status) !== -1) {
        returnResponse({ isSuccess: true });
      } else if ([400].indexOf(response.status) !== -1) {
        console.log(
          "Something went wrong hence getting error 400 bad request."
        );
        setError("error: 400 Bad Request.");
      }
      const responseData = await response.json();

      returnResponse(responseData);
    } catch (err) {
      console.log(JSON.stringify(err));
      setError(err.message || "Something went wrong.");
    }
    setIsLoading(false);
  }, []);

  return {
    isLoading,
    error,
    sendRequest,
  };
};

export default useHttpRequests;
